import { SwapCurrencies, SwapFeatures } from '@web/walter-lib/api'
import { keyBy } from 'lodash'
import { ModeTypes } from '~components/SwapWidget/const'

interface AvailableSwapCurrencies {
    fixed: Set<string>
    market: Set<string>
}

export const processSwap = (swapCurrencies?: SwapCurrencies, swapFeatures?: SwapFeatures) => {
    const tempSwapArray: AvailableSwapCurrencies = { fixed: new Set([]), market: new Set([]) }

    if (!swapCurrencies || !swapFeatures) {
        return tempSwapArray
    }

    if (swapFeatures?.features?.includes(ModeTypes.fixed)) {
        const fromFixedOptionsObject = keyBy(swapCurrencies?.fixed_currencies, 'from_currency')
        tempSwapArray.fixed = new Set([...tempSwapArray.fixed, ...Object.keys(fromFixedOptionsObject)])
    }

    if (swapFeatures?.features?.includes(ModeTypes.market)) {
        const fromMarketOptionsObject = keyBy(swapCurrencies?.market_currencies, 'from_currency')
        tempSwapArray.market = new Set([...tempSwapArray.market, ...Object.keys(fromMarketOptionsObject)])
    }

    return tempSwapArray
}
